import { gql } from '@apollo/client';

export const getStreetViewImageQuery = gql`
  query GetStreetViewImage(
    $address: HouseAddressInput!
    $correlationId: UUID!
  ) {
    streetViewLocation(address: $address, correlationId: $correlationId) {
      errorMessage
      found
      preAssignedUrl
    }
  }
`;

export default getStreetViewImageQuery;
